import { validateField } from '@/utils';
const fieldValidations = {
    name: { transitionKey: 'sendMail.name', types: ['require', 'max255'], errorKey: 'name' },
    title: { transitionKey: 'sendMail.title', types: ['max255'], errorKey: 'title' }
};

const onValidate = (field, mail, errorInfo) => {
    for (const [fieldCheck, config] of Object.entries(fieldValidations)) {
        if (field !== fieldCheck) continue;
        const { transitionKey, types, errorKey } = config;
        const validation = validateField.validate(mail[field], transitionKey, types);
        errorInfo[errorKey] = validation.errorInfo;
    }
};

const validateAllField = (mail, errorInfo) => {
    let check = true;
    for (const [field, config] of Object.entries(fieldValidations)) {
        const { transitionKey, types, errorKey } = config;
        const validation = validateField.validate(mail[field], transitionKey, types);
        check = validation.check && check;
        errorInfo[errorKey] = validation.errorInfo;
    }

    return check;
};

const getObjectData = (mail) => {
    return {
        name: mail.name,
        title: mail.title,
        content_add: mail.content
    };
};

export { onValidate, validateAllField, getObjectData };
